import React from "react";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import VideoPlayer from "react-video-js-player";
const Viewvideo = (props) => {
	const location = useLocation();
	var ID_FOR_VIDEO = "";
	var videoURL = "";
	var course_ID = "";

	function setProgress() {}

	useEffect(() => {
		console.log(props);
		console.log(location);
		// videoURL = location.aboutProps.
		videoURL = location?.aboutProps?.name;
		console.log(videoURL);

		if (videoURL !== undefined) {
			localStorage.setItem("video", videoURL);
		}
		if (videoURL == undefined) {
			videoURL = localStorage.getItem("video");
			// alert(videoURL)
		}

		console.log(location.pathname.split("/"));
		var array = location.pathname.split("/");
		ID_FOR_VIDEO = array[2];
		course_ID = array[3];
		// console.log(videoURL);
		// console.log(location.pathname.substring(11, location.pathname.length))
		ID_FOR_VIDEO = location.pathname.substring(
			11,
			location.pathname.length
		);
		return () => {
			//  localStorage.setItem("video", videoURL )
			//  alert(videoURL)
		};
	}, []);
	return (
		<div>
			<VideoPlayer
				onEnd={() => {
					setProgress();
				}}
				src={videoURL}
				poster="https://i.vimeocdn.com/video/972182691_130x73"
				width={window.innerWidth}
				height={window.innerHeight}
			/>
		</div>
	);
};

export default Viewvideo;
